import { useState } from "react";
import { copy } from "../copy";
import { backMeHref } from "../feed";
import { secondaryButton } from "../contest/ui";
import Icon from "./Icon";

type Props = { slug: string; contest: string; username: string };

// An entrant's Back Me link: the phone's share sheet where there is one,
// otherwise copied, otherwise shown to copy by hand.
export default function ShareBackMe({ slug, contest, username }: Props) {
  const t = copy.contest.backMe;
  const [state, setState] = useState<{ copied?: boolean; manual?: string }>({});
  const url = new URL(backMeHref(slug, username), window.location.origin).toString();

  const share = async () => {
    if (typeof navigator.share === "function") {
      try {
        await navigator.share({ title: t.shareTitle(contest), text: t.shareText(username, contest), url });
        return;
      } catch (err) {
        // Closing the share sheet is not a failure.
        if (err instanceof DOMException && err.name === "AbortError") return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setState({ copied: true });
    } catch {
      setState({ manual: url });
    }
  };

  return (
    <section data-testid="share-back-me" className="rounded-2xl border border-gold/30 bg-ground-raised p-5">
      <h3 className="font-headline text-xl uppercase leading-none text-chrome">{t.heading}</h3>
      <p className="mt-3 max-w-xl text-[12px] leading-relaxed text-chrome-dim">{t.sub}</p>
      <button type="button" onClick={share} className={`${secondaryButton} mt-4`}>
        <Icon name={state.copied ? "check" : "share"} className="h-4 w-4" />
        {state.copied ? t.copied : t.share}
      </button>
      {state.manual && (
        <p className="mt-3 break-all text-[12px] text-chrome">
          {t.manual} <span data-testid="back-me-link">{state.manual}</span>
        </p>
      )}
    </section>
  );
}
